import React from 'react';
import PropTypes from 'prop-types';
import Dropdown from '../Dropdown';

/**
Il componente NavDropDown è una variante della comune dropdown pensata per essere utilizzata all'interno della navigazione.
Il suo funzionamento è identico a quello della dropdown eccetto per lo stile di default applicato.
 */
const NavDropdown = ({ subtitle, title, ...others }) => (
  <Dropdown
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...others}
    classPrefix="navDropDown"
    toggleComponent={(
      <button
        className="navDropDown--toggle"
        type="button"
      >
        <span className="navDropDown__caret" />
        <div className="navDropDown__texts">
          <span className="navDropDown__title">{title}</span>
          <span className="navDropDown__subtitle">{subtitle}</span>
        </div>
      </button>
    )}
  />
);

NavDropdown.Item = Dropdown.Item;
NavDropdown.SubMenu = Dropdown.SubMenu;

NavDropdown.propTypes = {
  /** Sottotitolo visualizzato */
  subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  /** Titolo visualizzato */
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

NavDropdown.defaultProps = {
  subtitle: '',
  title: '',
};

export default NavDropdown;
